import { z } from 'zod';

export const createReviewSchema = z.object({
  taskId: z.string().uuid(),
  rating: z.number().int().min(1).max(5),
  comment: z.string().max(2000).optional(),
});

export const respondToReviewSchema = z.object({
  reviewId: z.string().uuid(),
  response: z.string().min(10).max(2000),
});

/** Admin moderation action on a review. */
export const moderateReviewSchema = z.object({
  decision: z.enum(['approved', 'rejected']),
  reason: z.string().max(500).optional(),
});

export const REVIEW_MODERATION_STATUS = ['pending', 'approved', 'rejected'] as const;
export type ReviewModerationStatus = (typeof REVIEW_MODERATION_STATUS)[number];

export type CreateReviewInput = z.infer<typeof createReviewSchema>;
export type RespondToReviewInput = z.infer<typeof respondToReviewSchema>;
export type ModerateReviewInput = z.infer<typeof moderateReviewSchema>;
